export default __webpack_public_path__ + "locales/lv/FillPDFDialog.json?hash=0dcfccb5f91dc6718be6ea4e3e9873e3";